import { Component, EventEmitter, Output, ViewChild } from "@angular/core";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { Helper } from "src/app/core/helpers/helper";

@Component({
  selector: "app-fix-fare-trip-modal",
  templateUrl: "./fix-fare-trip-modal.component.html",
  styleUrl: "./fix-fare-trip-modal.component.scss",
  standalone: false
})
export class FixFareTripModalComponent {
  fixFareModalRef!: NgbModalRef;
  modalConfig: any = { size: "md", centered: true, backdrop: "static" };

  @ViewChild("fixFareModal", { static: true }) fixFareModal!: NgbModal;

  @Output() fixFareEvent = new EventEmitter();

  constructor(public helper: Helper, private modalService: NgbModal) {}

  /**
   * Opens the modal with the specified configuration.
   * Sets up the result handling to close the modal on success or dismissal.
   */
  openModal(): void {
    this.fixFareModalRef = this.modalService.open(this.fixFareModal, this.modalConfig);
    this.fixFareModalRef.result.then(
      () => this.closeModal(),
      () => this.closeModal()
    );
  }

  /**
   * Emits the fixFareEvent with the provided boolean value.
   * Closes the modal after emitting the event.
   *
   * @param isFixFare A boolean indicating whether the fare is fixed.
   */
  onSubmit(isFixFare: boolean): void {
    this.fixFareEvent.emit(isFixFare);
    this.closeModal();
  }

  /**
   * Closes the modal.
   */
  closeModal(): void {
    this.fixFareModalRef.close();
  }
}
